export default __webpack_public_path__ + "static/w-1-beecb7034110cea7cee169d379b07293.webp";